<template>
  <div>
    <div class="row mb-5">
      <div class="subject-super w-100 mb-3">
        <span class="subject-title bg-white pr-3 pl-3 text-dark">{{ $t('import-from-excel-map.account-info') }}</span>
      </div>

      <div class="col-12">
        <nk-col-form-group class="color-gray" :label="$t(`sale.factor.f.${IS_PAYMENT ? 'debtorAccount' : 'creditorAccount'}`) + ':'" :labelSizes="{ sm: 6 }" :dataSizes="{ sm: 6 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
          <nk-dropdown-account v-model="localData.ourAccount" :options="getAccountOptions('ourAccount')" :tabindex="110"></nk-dropdown-account>
        </nk-col-form-group>
      </div>

      <div class="col-12">
        <nk-col-form-group class="color-gray" :label="$t(`sale.factor.f.${IS_PAYMENT ? 'creditorAccount' : 'debtorAccount'}`) + ':'" :labelSizes="{ sm: 6 }" :dataSizes="{ sm: 6 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
          <nk-dropdown-account v-model="localData.theirAccount" :options="getAccountOptions('theirAccount')" :tabindex="112"></nk-dropdown-account>
        </nk-col-form-group>
      </div>

      <div class="col-12">
        <nk-col-form-group class="color-gray" :label="$t('sale.factor.f.taxAccount') + ':'" :labelSizes="{ sm: 6 }" :dataSizes="{ sm: 6 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
          <nk-dropdown-account v-model="localData.taxAccount" :options="getAccountOptions('taxAccount')" :tabindex="114"></nk-dropdown-account>
        </nk-col-form-group>
      </div>

    </div>

    <div class="row mb-5" v-if="!IS_PAYMENT">
      <div class="subject-super w-100 mb-3">
        <span class="subject-title bg-white pr-3 pl-3 text-dark">{{ $t('import-from-excel-map.hawala-info') }}</span>
      </div>

      <div class="col-12">
        <nk-col-form-group :label="$t('sale.receipt-hawala.f.deliverer') + ':'" :labelSizes="{ sm: 6 }" :dataSizes="{ sm: 6 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
          <nk-dropdown-center v-model="localData.hawalaInfo.receiptor" :options="componentOptions.personel" :tabindex="116"></nk-dropdown-center>
        </nk-col-form-group>
      </div>

      <div class="col-12">
        <nk-col-form-group :label="$t('sale.receipt-hawala.f.account') + ':'" :labelSizes="{ sm: 6 }" :dataSizes="{ sm: 6 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
          <nk-dropdown-account v-model="localData.hawalaInfo.account" :options="componentOptions.account" :tabindex="118"></nk-dropdown-account>
        </nk-col-form-group>
      </div>

      <div class="col-12" v-for="index in maxHawalaCenterCols" :key="index">
        <nk-col-form-group :label="`${$t('sale.receipt-hawala.f.center')}${maxHawalaCenterCols > 1 ? index.toString() : ''}:`" :labelSizes="{ sm: 6 }" :dataSizes="{ sm: 6 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
          <nk-dropdown-center v-model="localData.hawalaInfo.floatingCenters[index - 1]" :options="createCenterOptions(index)" :tabindex="120 + index"></nk-dropdown-center>
        </nk-col-form-group>
      </div>

    </div>
  </div>
</template>
<script lang="ts">
  import { Account } from '@/classes/system/account'
  import { FloatingCenter } from '@/classes/system/floating-center'
  import validators, { Checker } from '@/statics/validators'
  import { defineComponent, PropType } from 'vue'
  import { mapGetters } from 'vuex'
  import cloneDeep from 'lodash/cloneDeep'

  interface IMapSettings {
    factorType: 'Sale' | 'Buy' | 'SaleReturn' | 'BuyReturn',
  }

  export default defineComponent({
    name: 'FactorHeaderImportExcel',

    props: {
      mapSettings: {
        type: Object as PropType<IMapSettings>,
        required: true,
      }
    },
    data() {
      return {
        localData: {
          ourAccount: null as Account | null,
          theirAccount: null as Account | null,
          taxAccount: null as Account | null,
          hawalaInfo: {
            receiptor: null as FloatingCenter | null,
            account: null as Account | null,
            floatingCenters: [] as FloatingCenter[],
          } as any
        },
        validators: {
          ourAccount: validators('required'),
          theirAccount: validators('required'),
          taxAccount: validators('required'),
        },
        autoAccountKeysMapper: { // [autoAccountKey, isDebtor]
          Sale: {
            ourAccount: ['Sale', false],
            theirAccount: ['AccountSide_Debtor', true],
            taxAccount: ['Taxes', false],
            productStockAccount: ['GoodsStock', false],
          },
          Buy: {
            ourAccount: ['Buy', true],
            theirAccount: ['AccountSide_Creditor', false],
            taxAccount: ['PaidTax', true],
          },
          SaleReturn: {
            ourAccount: ['ReturnFromSale', true],
            theirAccount: ['AccountSide_Debtor', false],
            taxAccount: ['PaidTax', true],
          },
          BuyReturn: {
            ourAccount: ['ReturnFromBuy', false],
            theirAccount: ['AccountSide_Creditor', true],
            taxAccount: ['Taxes', false],
            productStockAccount: ['GoodsStock', false]
          },
        },
        componentOptions: {
          personel: {
            rowIdentifier: 'id',
            searchable: true,
            required: true,
            baseAccountId: null,
            centerLevel: 0,
            remoteSearch: false,
            placeholder: this.$t('autoAccount.choose-center'),
            display: (item: FloatingCenter) => `${item.accountingCode} - ${item.name}`,
            searchableFields: ['name', 'accountingCode'],
            loadAllIfBaseAccountIsEmpty: true,
            selectorWidth: 350,
            showIfRelatedAccountIsEmpty: true,
            linkNewCenterToAccount: false,
            group: ['Personel'],
          },
          account: {
            isDebtor: true,// in hawala account is debtor
            formName: 'Hawala',
          },
        }
      }
    },
    computed: {
      ...mapGetters({
        findForm: 'forms/findFormByKey',
        getAutoAccountsItemsByKey: 'autoAccounts/getItemsByKey',
        getMaxCentersLevelByAccountId: 'floatingCenters/getMaxCentersLevelByAccountId',
      }),
      IS_PAYMENT() {
        return ['Buy', 'SaleReturn'].includes(this.mapSettings.factorType)
      },
      maxHawalaCenterCols() {
        let accountIds = this.findAccountsByFormName('Hawala', true, '')
        let max = 1
        for (var i = 0; i < accountIds.length; i++) {
          let x = this.getMaxCentersLevelByAccountId(accountIds[i])
          max = Math.max(max, x)
        }
        return max
      },
    },
    methods: {
      getLocalData() {

        if (this.validateInputs()) {
          const data = cloneDeep(this.localData)

          data.ourAccount = this.formatAccount(data.ourAccount as Account) as any
          data.theirAccount = this.formatAccount(data.theirAccount as Account) as any
          data.taxAccount = this.formatAccount(data.taxAccount as Account) as any

          if (!data.hawalaInfo?.account?.id) {
            delete data.hawalaInfo
          }
          else {
            data.hawalaInfo = {
              receiptor: data.hawalaInfo?.receiptor ? this.formatFloatingCenter(data.hawalaInfo.receiptor) : null,
              account: data.hawalaInfo?.account ? this.formatAccount(data.hawalaInfo.account as Account) as any : null,
              floatingCenters: data.hawalaInfo.floatingCenters.map((x: FloatingCenter) => this.formatFloatingCenter(x))
            } as any
          }

          return data
        }
        return false
      },
      formatAccount(acc: Account) {
        return {
          id: acc.id,
          name: acc.name,
          code: acc.code,
          accountingCode: acc.accountingCode
        }
      },
      formatFloatingCenter(center: FloatingCenter) {
        return {
          id: center.id,
          name: center.name,
          code: center.code,
          accountingCode: center.accountingCode
        }
      },
      validateInputs() {
        let checker = new Checker((type: string) => this.$t(`sale.factor.f.${type}`))
        let errors = checker.test(this.localData, this.validators)


        this.validationToast(errors)
        return errors.length === 0
      },
      getAccountOptions(key: 'ourAccount' | 'theirAccount' | 'taxAccount') {
        return {
          dropdownOptions: {
            selectorHeight: '400px',
          },
          autoAccountTypeKey: this.autoAccountKeysMapper[this.mapSettings.factorType][key][0],
          isDebtor: this.autoAccountKeysMapper[this.mapSettings.factorType][key][1],
          formName: this.mapSettings.factorType,
        }
      },
      findAccountsByFormName(formName: string, isDebtor: boolean, autoAccountTypeKey: string) {
        let keys = this.findForm(formName).types
        if (typeof isDebtor !== 'undefined')
          keys = keys.filter((x: any) => {
            return x.isDebtor === isDebtor
          })
        keys = keys.reduce((arr: any[], item: any) => {
          arr.push(item.key)
          return arr
        }, [])
        let accounts: any[] = []
        if (!keys) return accounts

        for (let key of keys) {
          if (autoAccountTypeKey && key !== autoAccountTypeKey)
            continue
          accounts.push(...this.getAutoAccountsItemsByKey(key))
        }

        accounts = accounts.reduce((list: any[], current: any) => {
          if (list.findIndex((x: any) => x.id === current.id) === -1) {
            list.push(current)
          }
          return list
        }, [])

        return accounts.map((x: any) => x.id)
      },
      createCenterOptions(index: number) {
        return {
          rowIdentifier: 'id',
          searchable: true,
          required: true,
          baseAccountId: this.localData.hawalaInfo.account ? this.localData.hawalaInfo.account.id : null,
          centerLevel: index,
          remoteSearch: false,
          placeholder: this.$t('autoAccount.choose-center'),
          display: (item: FloatingCenter) => `${item.accountingCode} - ${item.name}`,
          searchableFields: ['name', 'accountingCode'],
          selectorWidth: 350,
          loadAllIfBaseAccountIsEmpty: false,
          linkNewCenterToAccount: true,
          formName: 'Hawala',
          isDebtor: true
        }
      }
    }
  })

</script>